import type {ReactElement} from 'react'

import type {SectionProps as Props} from '../types'
import {Requirements} from './components/Requirements@desktop'
import {groupByWidgetId} from './index@desktop.utils'

export function RequirementsBlock(props: Props): ReactElement | null {
  const {requirements} = groupByWidgetId(props)

  if (requirements && requirements.length > 0) {
    return <Requirements widgets={requirements} />
  }
  return null
}
